import { render, staticRenderFns } from "./AddEventFormat.vue?vue&type=template&id=0b007ba6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventFormat.vue"
export default component.exports